<form class="theme-primary" [ngClass]="styles.wrapper" name="reportForm" #form="ngForm" (submit)="submit()">
	<div class="modal-header theme-accent-bg theme-accent-border">
		<h4 class="util-break-word theme-accent-txt" id="modal-title">
			{{ 'Media_Videos_Playback_ReportDialogHeader' | translate }}
		</h4>
	</div>
	<div class="modal-body">
		<vb-ui-form-group>
			<label for="reason" #uiLabel>
				{{ 'Media_Videos_Playback_ReportDialogLabel' | translate }}
			</label>
			<textarea #reportReason="ngModel" [(ngModel)]="reason" [ngClass]="styles.textArea" name="reason" rows="10" uiControl vbAutoFocus vbRequired vbUiTextArea>
			</textarea>
			<div *ngIf="reportReason.invalid" role="alert" vbUiErrorMessage uiValidation>
				<div *ngIf="reportReason.errors.required">{{ 'ThisFieldIsRequired' | translate }} </div>
			</div>
		</vb-ui-form-group>
	</div>
	<div class="modal-footer">
		<div class="float-right">
			<button type="button" (click)="cancel()" vbBtnSecondary class="margin-right-5"> {{ 'Cancel' | translate }} </button>
			<button type="submit" [disabled]="form.invalid" vbBtnPrimary> {{ 'UI_Submit' | translate }} </button>
		</div>
	</div>
</form>
